import { z } from 'zod';

export const cleanupZ = z.object({
  title: z.string().min(1, 'Title is required'),
  descriptionItems: z.array(z.string()).min(1, 'At least one description item is required'),
  organizationId: z.string().optional(),
  isTemplate: z.boolean().optional(),
  position: z.number().optional(),
  archived: z.boolean().optional(),
});

export type CleanupZ = z.infer<typeof cleanupZ>;
